var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stats-chart-analysis',{attrs:{"subtitle":_vm.subtitle,"title":_vm.title,"avatar":_vm.avatar}},[_c('line-chart',{style:({'max-height': '300px'}),attrs:{"data":_vm.data,"options":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }